import React from "react";
import { Grid, Paper, Typography, Container } from "@material-ui/core";
import { Link } from "gatsby";
import { basePath } from "../common/consts";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { useAnalyticsEvents } from "../analytics/events.home";

const CategoryItem = ({ item, lang }) => {
  const { clickCategoryEvent } = useAnalyticsEvents()

  const handleClick = async () => {
    clickCategoryEvent(lang, item?.prismicId, item?.data?.title?.text)
  }

  return (
    <Link to={`${basePath}${item?.lang}/category/${item?.prismicId}`} onClick={handleClick} >
      {(
        <Grid
          item
          xs={12}
          container
          direction="row"
          style={{ padding: "16px 0", borderBottom: "1px solid #F0F2F4" }}
        >
          <Grid item xs={10} style={{ borderRadius: "none" }} >
            <Container>
              <Typography variant="body2">{item?.data?.title?.text}</Typography>
            </Container>
          </Grid>
          <Grid item xs={2} container justifyContent="center" alignItems="center" >
            <ChevronRightIcon color="primary" />
          </Grid>
        </Grid>
      )}
    </Link>
  );
}

export default CategoryItem